import { gql } from '@apollo/client';

/* Win/loss + conversion reporting (POGO-12603 Phase 11). */

export const CRM_WIN_LOSS_BY_OWNER = gql`
    query CrmWinLossByOwner($filter: CrmReportFilterInput) {
        crmWinLossByOwner(filter: $filter) {
            ownerId
            ownerName
            won
            lost
            open
            winRate
        }
    }
`;

export const CRM_STAGE_CONVERSION = gql`
    query CrmStageConversion($filter: CrmReportFilterInput) {
        crmStageConversion(filter: $filter) {
            stageKey
            stageName
            order
            color
            isWon
            isLost
            count
            avgDaysInStage
        }
    }
`;
